
import { RevIllustration, RevLink, RevModal } from '@backmarket/design-system'
import { parse } from 'query-string'

import { MODAL_NAMES } from '@config/constants'
import { trackClick } from '@tracking/events'

import GradeDescription from '../../GradeDescription'
import Picker from '../../Picker'

import translations from './GradesModal.translations'

export default {
  components: {
    RevLink,
    RevModal,
    RevIllustration,
    GradeDescription,
    Picker,
  },
  props: {
    grades: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      disabledGradeIndex: null,
    }
  },
  computed: {
    translations: () => translations,
    modalName: () => MODAL_NAMES.PRODUCT.GRADES,
    activeGrade() {
      return this.grades.find((grade) => grade.selected)
    },
    image() {
      if (this.disabledGradeIndex !== null) {
        return (
          this.grades[this.disabledGradeIndex].images &&
          this.grades[this.disabledGradeIndex].images[0]
        )
      }

      return this.activeGrade.images && this.activeGrade.images[0]
    },
    pickers() {
      return this.grades.map(
        ({ backboxGrade, price, selected, isDisabled, id }) => ({
          backboxGrade,
          price,
          id,
          disabled: isDisabled,
          // no picker should be selected if clicking on an out of stock grade picker
          selected: selected && this.disabledGradeIndex === null,
        }),
      )
    },
    details() {
      if (this.disabledGradeIndex !== null) {
        return this.grades[this.disabledGradeIndex].paragraphs
      }

      return this.activeGrade.paragraphs
    },
    isDetailsDisabled() {
      return this.disabledGradeIndex !== null
    },
  },
  methods: {
    resetDisabledGradeIndex() {
      this.disabledGradeIndex = null
    },
    updateGrade(picker) {
      if (picker.disabled) {
        this.disabledGradeIndex = this.grades.findIndex(
          (grade) => grade.backboxGrade.value === picker.backboxGrade.value,
        )

        return
      }
      // this needs to run before evaluating the line after
      this.disabledGradeIndex = null
      // avoid vue-router redundant navigation warning
      const hash = parse(this.$route.hash)
      const { l } = hash

      if (parseInt(l, 10) === picker.backboxGrade.value) {
        return
      }

      trackClick({
        zone: 'grade_picker_modal',
        name: picker.backboxGrade.value,
        value: {
          listing_id: picker.id && picker.id.toString(),
          price: picker.price && picker.price.amount,
        },
      })

      this.$navigation.replace({
        type: 'internal',
        hash: { l: picker.backboxGrade.value },
      })
    },
    getPickerDescription({ disabled, price }) {
      return disabled ? this.$t(translations.alreadySold) : this.$t.price(price)
    },
  },
}
